/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/64/no-photo': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<g class="nc-icon-wrapper" _fill="#d1d1d1"><path pid="0" d="M7.868 51.89l13.8-13.8a11.983 11.983 0 0116.419-16.419L45.758 14h-1.169l-4.715-8.486A1 1 0 0039 5H25a1 1 0 00-.874.514L19.411 14H9a6.006 6.006 0 00-6 6v26a6.008 6.008 0 004.868 5.89zM55 14h-.758L42.329 25.913a11.983 11.983 0 01-16.416 16.416L16.242 52H55a6.006 6.006 0 006-6V20a6.006 6.006 0 00-6-6z"/><path pid="1" data-color="color-2" d="M3 62a1 1 0 01-.707-1.707l58-58a1 1 0 111.414 1.414l-58 58A1 1 0 013 62z"/></g>'
  }
})
